<!----------------BreadCrumb area----------------->
<!----------------BreadCrumb area----------------->

<section class="cus-breadcrumb-margin-left">
    <ol class="breadcrumb">
        <li class="breadcrumb-item">Home</li>
        <li class="breadcrumb-item">Vendors</li>
        <li class="breadcrumb-item active">{{vendorName}}</li>
    </ol>
</section>

<!----------------BreadCrumb area----------------->
<!----------------BreadCrumb area----------------->

<!----------------SubHeader area----------------->
<!----------------SubHeader area----------------->

<section>
    <div class="p-fluid">
        <div class="row p-mb-2">
            <div class="col-md-1"></div>
            <div class="col-md-10">
                <div class="card Title-bar-blue">
                    <div class="card-header">
                        <div class="col-md-12">
                            <div class="devcare-sub-header Title-bar-text">
                                Vendor Approval
                                <button style="font-size: 25px;height: 30px !important;width: 30px !important;color: #343a40 !important;border-radius: 50%;background-color: white;
                                margin-top: -3px;" pButton icon="pi pi-arrow-circle-left" type="button" label=""
                                    class="p-button-sm float-right"  (click)="backToPrev()"></button>
                                &nbsp;&nbsp;
                                <!-- <button style="height: 25px !important;width: 75px !important;color: white !important;" pButton                                
                                icon="pi pi-user-edit" type="button"
                                (click)="edit()" label="Edit"
                                class="p-button-sm float-right p-button-outlined p-mr-2"></button>     -->
                            </div>

                        </div>
                    </div>
                </div>
            </div>
            <div class="col-md-1"></div>
        </div>
    </div>
</section>

<!----------------SubHeader area----------------->
<!----------------SubHeader area----------------->

<!----------------main area----------------->
<!----------------main area----------------->

<section>
    <div class="p-fluid">
        <div class="row">
            <div class="col-md-1"></div>
            <div class="col-md-10">
                <div class=" p-p-1">
                    <div>
                        <p-accordion [multiple]="true">
                            <p-accordionTab header="Company Profile" [selected]="true">
                                <!-- <ng-template pTemplate="header">
                                    <div class="ml-auto">
                                        <button style="height: 25px !important;width: 75px !important;" pButton
                                            icon="pi pi-user-edit" type="button" (click)="redirectToEdit()" label="Edit"
                                            class="p-button-sm float-right p-mr-2 p-jc-between"></button>
                                    </div>
                                </ng-template> -->
                                <div class="p-fluid p-formgrid p-grid">
                                    <div class="p-field p-col-12 col-sm-3 col-md-3 col-lg-3">
                                        <div class="p-text-bold">Entity Type</div>
                                        <div class="p-text-normal">{{entitytype}}</div>
                                    </div>
                                    <div class="p-field p-col-12 col-sm-3 col-md-3 col-lg-3">
                                        <div class="p-text-bold">Vendor Name</div>
                                        <div class="p-text-normal">{{vendorName}}</div>
                                    </div>
                                    <div class="p-field p-col-12 col-sm-3 col-md-3 col-lg-3">
                                        <div class="p-text-bold">Tax ID Number</div>
                                        <div class="p-text-normal">{{taxIdNumber | mask:'00-0000000'}}</div>
                                    </div>
                                    <div class="p-field p-col-12 col-sm-3 col-md-3 col-lg-3">
                                        <div class="p-text-bold">Email Address</div>
                                        <div class="p-text-normal">{{vendorEmailId}}</div>
                                    </div>                                  
                                    <div class="p-field p-col-12 col-sm-3 col-md-3 col-lg-3">
                                        <div class="p-text-bold">Web Address</div>
                                        <div class="p-text-normal">{{webAddress}}</div>
                                    </div>
                                    <div class="p-field p-col-12 col-sm-3 col-md-3 col-lg-3">
                                        <div class="p-text-bold">Phone</div>
                                        <div class="p-text-normal">{{vendorPhoneNumber | mask:'(000) 000-0000'}}</div>
                                    </div>
                                    <div class="p-field p-col-12 col-sm-3 col-md-3 col-lg-3">
                                        <div class="p-text-bold">Ext. Number</div>
                                        <div class="p-text-normal">{{vendorPhoneExtNumber }}</div>
                                    </div>
                                    <div class="p-field p-col-12 col-sm-3 col-md-3 col-lg-3">
                                        <div class="p-text-bold">Fax Number</div>
                                        <div class="p-text-normal">{{faxNumber | mask:'(000) 000-0000'}}</div>
                                    </div>
                                    <div class="p-field p-col-12 col-sm-3 col-md-3 col-lg-3">
                                        <div class="p-text-bold">Address Line 1</div>
                                        <div class="p-text-normal">{{addressLine1}}</div>
                                    </div>
                                    <div class="p-field p-col-12 col-sm-3 col-md-3 col-lg-3">
                                        <div class="p-text-bold">Address Line 2</div>
                                        <div class="p-text-normal">{{addressLine2}}</div>
                                    </div>
                                    <div class="p-field p-col-12 col-sm-3 col-md-3 col-lg-3">
                                        <div class="p-text-bold">State</div>
                                        <div class="p-text-normal">{{stateName}}</div>
                                    </div>
                                    <div class="p-field p-col-12 col-sm-3 col-md-3 col-lg-3">
                                        <div class="p-text-bold">City</div>
                                        <div class="p-text-normal">{{city}}</div>
                                    </div>
                                    <div class="p-field p-col-12 col-sm-3 col-md-3 col-lg-3">
                                        <div class="p-text-bold">Zip Code</div>
                                        <div class="p-text-normal">{{zipCode}}</div>
                                    </div>
                                    <div class="p-field p-col-12 col-sm-3 col-md-3 col-lg-3">
                                        <div class="p-text-bold">Zip Code Ext</div>
                                        <div class="p-text-normal">{{zipCodeExt}}</div>
                                    </div>
                                    <div class="p-field p-col-12 col-sm-3 col-md-3 col-lg-3">
                                        <div class="p-text-bold">Country</div>
                                        <div class="p-text-normal">USA</div>
                                    </div>
                                    <div class="p-field p-col-12 col-sm-3 col-md-3 col-lg-3">
                                        <div class="p-text-bold">Payment Terms</div>
                                        <div class="p-text-normal">{{paymentTerms}}</div>
                                    </div>
                                    <div class="p-field p-col-12 col-sm-3 col-md-3 col-lg-3">
                                        <div class="p-text-bold">Invoice Terms</div>
                                        <div class="p-text-normal">{{invoiceTerms}}</div>
                                    </div>
                                </div>
                            </p-accordionTab>
                        </p-accordion>
                    </div>

                </div>
                <div class=" p-p-1">
                    <div>
                        <p-accordion [multiple]="true">
                            <p-accordionTab header="Company Details" [selected]="true">
                                <!-- <ng-template pTemplate="header">
                                    <div class="ml-auto">
                                        <button style="height: 25px !important;width: 75px !important;" pButton
                                            icon="pi pi-user-edit" type="button" (click)="redirectToEdit()" label="Edit"
                                            class="p-button-sm float-right p-mr-2 p-jc-between"></button>
                                    </div>
                                </ng-template> -->
                                <div class="p-fluid p-formgrid p-grid">
                                    <div class="p-field p-col-12 col-sm-12 col-md-12 col-lg-12">
                                        <div class="p-text-bold">Company’s Key Capabilities</div>
                                        <div class="p-text-normal">
                                            <div #companysKeyCapabilitiesContainer></div>
                                        </div>
                                    </div>
                                    <div class="p-field p-col-12 col-sm-12 col-md-12 col-lg-12">
                                        <div class="p-text-bold">Corporate History</div>
                                        <div class="p-text-normal">
                                            <div #corporateHistoryContainer></div>
                                        </div>
                                    </div>
                                    <div class="p-field p-col-12 col-sm-6 col-md-6 col-lg-6">
                                        <div class="p-text-bold">Company Establishment(Year)</div>
                                        <div class="p-text-normal">{{companyEstablishment}}</div>
                                    </div>
                                    <div class="p-field p-col-12 col-sm-6 col-md-6 col-lg-6">
                                        <div class="p-text-bold">Business Certifications</div>
                                        <div class="p-text-normal">{{businessCertifications}}</div>
                                    </div>
                                    <!--<div class="p-fluid p-formgrid p-grid">
                                    <div class="p-field p-col-12 p-md-3">
                                        <div class="label-grey text-bold">Awards & Certifications</div>
                                        <div class="label-size-15"></div>
                                    </div>
                                    <div class="p-field p-col-12 p-md-5">
                                        <div class="text-bold label-grey">Is your company registered in E-Verify?</div>
                                    <div class="label-size-15">{{isEVerifyRegistered?'Yes':'No'}}</div>
                                    </div>
                                </div>-->
                                <div class="p-field p-col-12 col-sm-12 col-md-12 col-lg-12">
                                    <div class="p-text-sm custom-title-bar p-text-bold">Headquarters / Branches</div> 
                                    <div class="p-fluid p-formgrid p-grid" *ngFor="let onshoreField of onshoreFields">
                                        <div class="p-field p-col-12 col-sm-3 col-md-3 col-lg-3">
                                            <div class="p-text-bold">Contact Name</div>
                                            <div class="p-text-normal">{{onshoreField.contactName}}</div>
                                        </div>
                                        <div class="p-field p-col-12 col-sm-3 col-md-3 col-lg-3">
                                            <div class="p-text-bold">Phone</div>
                                            <div class="p-text-normal">{{onshoreField.phone| mask:'(000) 000-0000'}}</div>
                                        </div>
                                        <div class="p-field p-col-12 col-sm-3 col-md-3 col-lg-3">
                                            <div class="p-text-bold">Office City/State</div>
                                            <div class="p-text-normal">{{onshoreField.officeCityState}}</div>
                                        </div>
                                        <div class="p-field p-col-12 col-sm-3 col-md-3 col-lg-3">
                                            <div class="p-text-bold">Address</div>
                                            <div class="p-text-normal">{{onshoreField.address}}</div>
                                        </div>
                                    </div>                                     
                                </div>

                                <div class="p-field p-col-12 col-sm-12 col-md-12 col-lg-12">
                                    <div class="p-text-sm custom-title-bar  p-text-bold">International Offices</div> 
                                    <div class="p-fluid p-formgrid p-grid" *ngFor="let offshoreField of offshoreFields">
                                        <div class="p-field p-col-12 col-sm-3 col-md-3 col-lg-3">
                                            <div class="p-text-bold">Address</div>
                                            <div class="p-text-normal">{{offshoreField.address}}</div>
                                        </div>
                                        <div class="p-field p-col-12 col-sm-3 col-md-3 col-lg-3">
                                            <div class="p-text-bold">City</div>
                                            <div class="p-text-normal">{{offshoreField.city}}</div>
                                        </div>
                                        <div class="p-field p-col-12 col-sm-3 col-md-3 col-lg-3">
                                            <div class="p-text-bold">State</div>
                                            <div class="p-text-normal">{{offshoreField.state}}</div>
                                        </div>
                                        <div class="p-field p-col-12 col-sm-3 col-md-3 col-lg-3">
                                            <div class="p-text-bold">Country</div>
                                            <div class="p-text-normal">{{offshoreField.country}}</div>
                                        </div>
                                    </div>                                     
                                </div>
                                    <!-- <div class="p-field p-col-12 col-sm-3 col-md-3 col-lg-3">
                                        <div class="p-text-bold"></div>
                                        <div class="p-text-normal"></div>
                                    </div>
                                    <div class="p-field p-col-12 col-sm-3 col-md-3 col-lg-3">
                                        <div class="p-text-bold"></div>
                                        <div class="p-text-normal"></div>
                                    </div> -->
                                    <div class="p-field p-col-12 col-sm-12 col-md-12 col-lg-12">
                                        <div class="p-text-bold">Awards & Certifications</div>
                                        <div class="p-text-normal">
                                            <div #awardsAndCertificationsContainer></div>
                                        </div>
                                    </div>
                                 
                                    <div class="p-field p-col-12 col-sm-12 col-md-12 col-lg-12">
                                        <div class="p-text-sm custom-title-bar p-text-bold">Company Revenue</div> 
                                        <div class="p-fluid p-formgrid p-grid">
                                            <div class="p-field p-col-12 col-sm-4 col-md-4 col-lg-4">
                                                <div class="p-text-bold">{{lastYear}}&nbsp;Revenue</div>
                                                <div class="p-text-normal">{{companyRevenueLastYear}}</div>
                                            </div>
                                            <div class="p-field p-col-12 col-sm-4 col-md-4 col-lg-4">
                                                <div class="p-text-bold">{{last2YearBefore}}&nbsp;Revenue</div>
                                                <div class="p-text-normal">{{companyRevenue2YearsBefore}}</div>
                                            </div>
                                            <div class="p-field p-col-12 col-sm-4 col-md-4 col-lg-4">
                                                <div class="p-text-bold">{{last3YearBefore}}&nbsp;Revenue</div>
                                                <div class="p-text-normal">{{companyRevenue3YearsBefore}}</div>
                                            </div>                                       
                                        </div>                                     
                                    </div>
                                    <div class="p-field p-col-12 col-sm-4 col-md-4 col-lg-4">
                                        <div class="p-text-bold">No. of W2 Employees</div>
                                        <div class="p-text-normal">{{noofW2Employees}}</div>
                                    </div>
                                    <div class="p-field p-col-12 col-sm-4 col-md-4 col-lg-4">
                                        <div class="p-text-bold">No. of 1099/C2C Consultant</div>
                                        <div class="p-text-normal">{{noofC2CConsultant}}</div>
                                    </div>
                                    <div class="p-field p-col-12 col-sm-4 col-md-4 col-lg-4">
                                        <div class="p-text-bold">Is your company registered in E-Verify?</div>
                                        <div class="p-text-normal">{{isEVerifyRegistered?'Yes':'No'}}</div>
                                    </div>
                                    <div class="p-field p-col-12 col-sm-8 col-md-8 col-lg-8">
                                        <div class="p-text-bold">Does your company offer Affordable Care Act (ACA) compliant coverage to all of your contract employees? <span class="p-text-normal">{{isOfferACAAct?'Yes':'No'}}</span></div>
                                        <!-- <div class="p-text-normal">{{isOfferACAAct?'Yes':'No'}}</div> -->
                                    </div>  
                                    <div class="p-field p-col-12 col-sm-7 col-md-7 col-lg-7">
                                        <div class="p-text-bold">Are you specialized in training OPT/CPT Students/H4 EAD employees?</div>
                                        <div class="p-text-normal">{{isOPTStudents?'Yes':'No'}}</div>
                                    </div>
                                    <div class="p-field p-col-12 col-sm-5 col-md-5 col-lg-5">
                                        <div class="p-text-bold">How many no. of trained candidates available?</div>
                                        <div class="p-text-normal">{{numberofotpcandidates}}</div>
                                    </div>
                                    <div class="p-field p-col-12 col-sm-12 col-md-12 col-lg-12">
                                        <div class="p-text-bold">What technology do you train them?</div>
                                        <div class="p-text-normal">{{technologytrain}}</div>
                                    </div>
                                    <div class="p-field p-col-12 col-sm-4 col-md-4 col-lg-4">
                                        <div class="p-text-bold">Do you support TN Visa?</div>
                                        <div class="p-text-normal">{{isSupportTNVisa?'Yes':'No'}}</div>
                                    </div>
                                    <div class="p-field p-col-12 col-sm-4 col-md-4 col-lg-4">
                                        <div class="p-text-bold">TN Visa Countries</div>
                                        <div class="p-text-normal">{{selectedTNVisaCountries}}</div>
                                    </div>
                                    <div class="p-field p-col-12 col-sm-4 col-md-4 col-lg-4">
                                        <div class="p-text-bold">No. of available TN visa candidates?</div>
                                        <div class="p-text-normal">{{noofTNVisaCandidates}}</div>
                                    </div>                                                                  
                                    <div class="p-field p-col-12 col-sm-12 col-md-12 col-lg-12">
                                        <div class="p-text-bold">What is the size of your available candidates on bench?</div>
                                        <div class="p-text-normal">
                                            <div #availableCandidateBenchContainer></div>
                                        </div>
                                    </div>
                                    <div class="p-field p-col-12 col-sm-12 col-md-12 col-lg-12">
                                        <div class="p-text-sm custom-title-bar p-text-bold">No. of candidates available in each state</div> 
                                        <div class="p-fluid p-formgrid p-grid">
                                            <div class="p-field p-col-12 col-sm-2 col-md-2 col-lg-2">
                                                <div class="p-text-bold">Alabama</div>
                                                <div class="p-text-normal">{{alabama}}</div>
                                            </div>
                                            <div class="p-field p-col-12 col-sm-2 col-md-2 col-lg-2">
                                                <div class="p-text-bold">Alaska</div>
                                                <div class="p-text-normal">{{alaska}}</div>
                                            </div>
                                            <div class="p-field p-col-12 col-sm-2 col-md-2 col-lg-2">
                                                <div class="p-text-bold">Arizona</div>
                                                <div class="p-text-normal">{{arizona}}</div>
                                            </div>
                                            <div class="p-field p-col-12 col-sm-2 col-md-2 col-lg-2">
                                                <div class="p-text-bold">Arkansas</div>
                                                <div class="p-text-normal">{{arkansas}}</div>
                                            </div>   
                                            <div class="p-field p-col-12 col-sm-2 col-md-2 col-lg-2">
                                                <div class="p-text-bold">California</div>
                                                <div class="p-text-normal">{{california}}</div>
                                            </div>   
                                            <div class="p-field p-col-12 col-sm-2 col-md-2 col-lg-2">
                                                <div class="p-text-bold">Colorado</div>
                                                <div class="p-text-normal">{{colorado}}</div>
                                            </div>   
                                            <div class="p-field p-col-12 col-sm-2 col-md-2 col-lg-2">
                                                <div class="p-text-bold">Connecticut</div>
                                                <div class="p-text-normal">{{connecticut}}</div>
                                            </div>   
                                            <div class="p-field p-col-12 col-sm-2 col-md-2 col-lg-2">
                                                <div class="p-text-bold">Delaware</div>
                                                <div class="p-text-normal">{{delaware}}</div>
                                            </div> 
                                            <div class="p-field p-col-12 col-sm-2 col-md-2 col-lg-2">
                                                <div class="p-text-bold">Florida</div>
                                                <div class="p-text-normal">{{florida}}</div>
                                            </div>   
                                            <div class="p-field p-col-12 col-sm-2 col-md-2 col-lg-2">
                                                <div class="p-text-bold">Georgia</div>
                                                <div class="p-text-normal">{{georgia}}</div>
                                            </div>   
                                            <div class="p-field p-col-12 col-sm-2 col-md-2 col-lg-2">
                                                <div class="p-text-bold">Hawaii</div>
                                                <div class="p-text-normal">{{hawaii}}</div>
                                            </div> 
                                            <div class="p-field p-col-12 col-sm-2 col-md-2 col-lg-2">
                                                <div class="p-text-bold">Idaho</div>
                                                <div class="p-text-normal">{{idaho}}</div>
                                            </div>
                                            <div class="p-field p-col-12 col-sm-2 col-md-2 col-lg-2">
                                                <div class="p-text-bold">Illinois</div>
                                                <div class="p-text-normal">{{illinois}}</div>
                                            </div>
                                            <div class="p-field p-col-12 col-sm-2 col-md-2 col-lg-2">
                                                <div class="p-text-bold">Indiana</div>
                                                <div class="p-text-normal">{{indiana}}</div>
                                            </div>
                                            <div class="p-field p-col-12 col-sm-2 col-md-2 col-lg-2">
                                                <div class="p-text-bold">Iowa</div>
                                                <div class="p-text-normal">{{iowa}}</div>
                                            </div>
                                            <div class="p-field p-col-12 col-sm-2 col-md-2 col-lg-2">
                                                <div class="p-text-bold">Kansas</div>
                                                <div class="p-text-normal">{{kansas}}</div>
                                            </div>
                                            <div class="p-field p-col-12 col-sm-2 col-md-2 col-lg-2">
                                                <div class="p-text-bold">Kentucky</div>
                                                <div class="p-text-normal">{{kentucky}}</div>
                                            </div>
                                            <div class="p-field p-col-12 col-sm-2 col-md-2 col-lg-2">
                                                <div class="p-text-bold">Louisiana</div>
                                                <div class="p-text-normal">{{louisiana}}</div>
                                            </div>
                                            <div class="p-field p-col-12 col-sm-2 col-md-2 col-lg-2">
                                                <div class="p-text-bold">maine</div>
                                                <div class="p-text-normal">{{maine}}</div>
                                            </div>
                                            <div class="p-field p-col-12 col-sm-2 col-md-2 col-lg-2">
                                                <div class="p-text-bold">Maryland</div>
                                                <div class="p-text-normal">{{maryland}}</div>
                                            </div>
                                            <div class="p-field p-col-12 col-sm-2 col-md-2 col-lg-2">
                                                <div class="p-text-bold">Massachusetts</div>
                                                <div class="p-text-normal">{{massachusetts}}</div>
                                            </div>
                                            <div class="p-field p-col-12 col-sm-2 col-md-2 col-lg-2">
                                                <div class="p-text-bold">Michigan</div>
                                                <div class="p-text-normal">{{michigan}}</div>
                                            </div>
                                            <div class="p-field p-col-12 col-sm-2 col-md-2 col-lg-2">
                                                <div class="p-text-bold">Minnesota</div>
                                                <div class="p-text-normal">{{minnesota}}</div>
                                            </div>
                                            <div class="p-field p-col-12 col-sm-2 col-md-2 col-lg-2">
                                                <div class="p-text-bold">Mississippi</div>
                                                <div class="p-text-normal">{{mississippi}}</div>
                                            </div>
                                            <div class="p-field p-col-12 col-sm-2 col-md-2 col-lg-2">
                                                <div class="p-text-bold">Missouri</div>
                                                <div class="p-text-normal">{{missouri}}</div>
                                            </div>
                                            <div class="p-field p-col-12 col-sm-2 col-md-2 col-lg-2">
                                                <div class="p-text-bold">Montana</div>
                                                <div class="p-text-normal">{{montana}}</div>
                                            </div>
                                            <div class="p-field p-col-12 col-sm-2 col-md-2 col-lg-2">
                                                <div class="p-text-bold">Nebraska</div>
                                                <div class="p-text-normal">{{nebraska}}</div>
                                            </div>
                                            <div class="p-field p-col-12 col-sm-2 col-md-2 col-lg-2">
                                                <div class="p-text-bold">Nevada</div>
                                                <div class="p-text-normal">{{nevada}}</div>
                                            </div>
                                            <div class="p-field p-col-12 col-sm-2 col-md-2 col-lg-2">
                                                <div class="p-text-bold">New Hampshire</div>
                                                <div class="p-text-normal">{{newHampshire}}</div>
                                            </div>
                                            <div class="p-field p-col-12 col-sm-2 col-md-2 col-lg-2">
                                                <div class="p-text-bold">New Jersey</div>
                                                <div class="p-text-normal">{{newJersey}}</div>
                                            </div>
                                            <div class="p-field p-col-12 col-sm-2 col-md-2 col-lg-2">
                                                <div class="p-text-bold">New Mexico</div>
                                                <div class="p-text-normal">{{newMexico}}</div>
                                            </div>
                                            <div class="p-field p-col-12 col-sm-2 col-md-2 col-lg-2">
                                                <div class="p-text-bold">New York</div>
                                                <div class="p-text-normal">{{newYork}}</div>
                                            </div>
                                            <div class="p-field p-col-12 col-sm-2 col-md-2 col-lg-2">
                                                <div class="p-text-bold">North Carolina</div>
                                                <div class="p-text-normal">{{northCarolina}}</div>
                                            </div>
                                            <div class="p-field p-col-12 col-sm-2 col-md-2 col-lg-2">
                                                <div class="p-text-bold">North Dakota</div>
                                                <div class="p-text-normal">{{northDakota}}</div>
                                            </div>
                                            <div class="p-field p-col-12 col-sm-2 col-md-2 col-lg-2">
                                                <div class="p-text-bold">Ohio</div>
                                                <div class="p-text-normal">{{ohio}}</div>
                                            </div>
                                            <div class="p-field p-col-12 col-sm-2 col-md-2 col-lg-2">
                                                <div class="p-text-bold">Oklahoma</div>
                                                <div class="p-text-normal">{{oklahoma}}</div>
                                            </div>
                                            <div class="p-field p-col-12 col-sm-2 col-md-2 col-lg-2">
                                                <div class="p-text-bold">Oregon</div>
                                                <div class="p-text-normal">{{oregon}}</div>
                                            </div>
                                            <div class="p-field p-col-12 col-sm-2 col-md-2 col-lg-2">
                                                <div class="p-text-bold">Pennsylvania</div>
                                                <div class="p-text-normal">{{pennsylvania}}</div>
                                            </div>
                                            <div class="p-field p-col-12 col-sm-2 col-md-2 col-lg-2">
                                                <div class="p-text-bold">Rhode Island</div>
                                                <div class="p-text-normal">{{rhodeIsland}}</div>
                                            </div>
                                            <div class="p-field p-col-12 col-sm-2 col-md-2 col-lg-2">
                                                <div class="p-text-bold">South Carolina</div>
                                                <div class="p-text-normal">{{southCarolina}}</div>
                                            </div>
                                            <div class="p-field p-col-12 col-sm-2 col-md-2 col-lg-2">
                                                <div class="p-text-bold">South Dakota</div>
                                                <div class="p-text-normal">{{southDakota}}</div>
                                            </div> <div class="p-field p-col-12 col-sm-2 col-md-2 col-lg-2">
                                                <div class="p-text-bold">Tennessee</div>
                                                <div class="p-text-normal">{{tennessee}}</div>
                                            </div>
                                            <div class="p-field p-col-12 col-sm-2 col-md-2 col-lg-2">
                                                <div class="p-text-bold">Texas</div>
                                                <div class="p-text-normal">{{texas}}</div>
                                            </div>
                                            <div class="p-field p-col-12 col-sm-2 col-md-2 col-lg-2">
                                                <div class="p-text-bold">Utah</div>
                                                <div class="p-text-normal">{{utah}}</div>
                                            </div>
                                            <div class="p-field p-col-12 col-sm-2 col-md-2 col-lg-2">
                                                <div class="p-text-bold">Vermont</div>
                                                <div class="p-text-normal">{{vermont}}</div>
                                            </div>
                                            <div class="p-field p-col-12 col-sm-2 col-md-2 col-lg-2">
                                                <div class="p-text-bold">Virginia</div>
                                                <div class="p-text-normal">{{virginia}}</div>
                                            </div>
                                            <div class="p-field p-col-12 col-sm-2 col-md-2 col-lg-2">
                                                <div class="p-text-bold">Washington</div>
                                                <div class="p-text-normal">{{washington}}</div>
                                            </div>
                                            <div class="p-field p-col-12 col-sm-2 col-md-2 col-lg-2">
                                                <div class="p-text-bold">West Virginia</div>
                                                <div class="p-text-normal">{{westVirginia}}</div>
                                            </div>
                                            <div class="p-field p-col-12 col-sm-2 col-md-2 col-lg-2">
                                                <div class="p-text-bold">Wisconsin</div>
                                                <div class="p-text-normal">{{wisconsin}}</div>
                                            </div>
                                            <div class="p-field p-col-12 col-sm-2 col-md-2 col-lg-2">
                                                <div class="p-text-bold">Wyoming</div>
                                                <div class="p-text-normal">{{wyoming}}</div>
                                            </div>
                                            <!-- <div class="p-field p-col-12 col-sm-2 col-md-2 col-lg-2">
                                                <div class="p-text-bold">Alabama</div>
                                                <div class="p-text-normal">{{alabama}}</div>
                                            </div> -->
                                                                                    
                                        </div>                                     
                                    </div>
                                </div>                                                             
                            </p-accordionTab>
                        </p-accordion>
                    </div>

                </div>
                <div class="p-p-1">
                    <div>
                        <p-accordion [multiple]="true">
                            <p-accordionTab header="Delivery Teams" [selected]="true">
                                <div class="p-fluid p-formgrid p-grid">
                                    <div class="p-field p-col-12 col-sm-12 col-md-12 col-lg-12">
                                        <div class="p-text-bold">Leadership And Recruiting Teams</div>
                                        <div class="p-text-normal">
                                            <div #leadershipContainer></div>
                                        </div>
                                    </div>
                                    <div class="p-field p-col-12 col-sm-12 col-md-12 col-lg-12">
                                        <div class="p-text-sm custom-title-bar p-text-bold">Company Points of Contact</div> 
                                        <div class="p-text-sm custom-title-bar1 p-text-bold">Owner / President</div> 
                                        <div class="p-fluid p-formgrid p-grid">
                                            <div class="p-field p-col-12 col-sm-2 col-md-2 col-lg-2">
                                                <div class="p-text-bold">Name</div>
                                                <div class="p-text-normal">{{ownerName}}</div>
                                            </div>
                                            <div class="p-field p-col-12 col-sm-3 col-md-3 col-lg-3">
                                                <div class="p-text-bold">Title</div>
                                                <div class="p-text-normal">{{ownerTitle}}</div>
                                            </div>
                                            <div class="p-field p-col-12 col-sm-3 col-md-3 col-lg-3">
                                                <div class="p-text-bold">Email</div>
                                                <div class="p-text-normal">{{ownerEmail}}</div>
                                            </div>     
                                            <div class="p-field p-col-12 col-sm-2 col-md-2 col-lg-2">
                                                <div class="p-text-bold">Phone</div>
                                                <div class="p-text-normal">{{ownerPhone| mask:'(000) 000-0000'}}</div>
                                            </div>      
                                            <div class="p-field p-col-12 col-sm-2 col-md-2 col-lg-2">
                                                <div class="p-text-bold">Alternate Phone</div>
                                                <div class="p-text-normal">{{ownerAlternatePhone| mask:'(000) 000-0000'}}</div>
                                            </div>                              
                                        </div> 
                                        <div class="p-text-sm custom-title-bar1 p-text-bold">Recruiting /Delivery</div> 
                                        <div class="p-fluid p-formgrid p-grid">
                                            <div class="p-field p-col-12 col-sm-2 col-md-2 col-lg-2">
                                                <div class="p-text-bold">Name</div>
                                                <div class="p-text-normal">{{recruitingName}}</div>
                                            </div>
                                            <div class="p-field p-col-12 col-sm-3 col-md-3 col-lg-3">
                                                <div class="p-text-bold">Title</div>
                                                <div class="p-text-normal">{{recruitingTitle}}</div>
                                            </div>
                                            <div class="p-field p-col-12 col-sm-3 col-md-3 col-lg-3">
                                                <div class="p-text-bold">Email</div>
                                                <div class="p-text-normal">{{recruitingEmail}}</div>
                                            </div>     
                                            <div class="p-field p-col-12 col-sm-2 col-md-2 col-lg-2">
                                                <div class="p-text-bold">Phone</div>
                                                <div class="p-text-normal">{{recruitingPhone| mask:'(000) 000-0000'}}</div>
                                            </div>      
                                            <div class="p-field p-col-12 col-sm-2 col-md-2 col-lg-2">
                                                <div class="p-text-bold">Alternate Phone</div>
                                                <div class="p-text-normal">{{recruitingAlternatePhone| mask:'(000) 000-0000'}}</div>
                                            </div>                              
                                        </div>   
                                        <div class="p-text-sm custom-title-bar1  p-text-bold">Financial /Auditing and Compliance</div> 
                                        <div class="p-fluid p-formgrid p-grid">
                                            <div class="p-field p-col-12 col-sm-2 col-md-2 col-lg-2">
                                                <div class="p-text-bold">Name</div>
                                                <div class="p-text-normal">{{financialName}}</div>
                                            </div>
                                            <div class="p-field p-col-12 col-sm-3 col-md-3 col-lg-3">
                                                <div class="p-text-bold">Title</div>
                                                <div class="p-text-normal">{{financialTitle}}</div>
                                            </div>
                                            <div class="p-field p-col-12 col-sm-3 col-md-3 col-lg-3">
                                                <div class="p-text-bold">Email</div>
                                                <div class="p-text-normal">{{financialEmail}}</div>
                                            </div>     
                                            <div class="p-field p-col-12 col-sm-2 col-md-2 col-lg-2">
                                                <div class="p-text-bold">Phone</div>
                                                <div class="p-text-normal">{{financialPhone| mask:'(000) 000-0000'}}</div>
                                            </div>      
                                            <div class="p-field p-col-12 col-sm-2 col-md-2 col-lg-2">
                                                <div class="p-text-bold">Alternate Phone</div>
                                                <div class="p-text-normal">{{financialAlternatePhone| mask:'(000) 000-0000'}}</div>
                                            </div>                              
                                        </div>  
                                        <div class="p-text-sm custom-title-bar1 p-text-bold">Accounting</div> 
                                        <div class="p-fluid p-formgrid p-grid">
                                            <div class="p-field p-col-12 col-sm-2 col-md-2 col-lg-2">
                                                <div class="p-text-bold">Name</div>
                                                <div class="p-text-normal">{{accountingName}}</div>
                                            </div>
                                            <div class="p-field p-col-12 col-sm-3 col-md-3 col-lg-3">
                                                <div class="p-text-bold">Title</div>
                                                <div class="p-text-normal">{{accountingTitle}}</div>
                                            </div>
                                            <div class="p-field p-col-12 col-sm-3 col-md-3 col-lg-3">
                                                <div class="p-text-bold">Email</div>
                                                <div class="p-text-normal">{{accountingEmail}}</div>
                                            </div>     
                                            <div class="p-field p-col-12 col-sm-2 col-md-2 col-lg-2">
                                                <div class="p-text-bold">Phone</div>
                                                <div class="p-text-normal">{{accountingPhone| mask:'(000) 000-0000'}}</div>
                                            </div>      
                                            <div class="p-field p-col-12 col-sm-2 col-md-2 col-lg-2">
                                                <div class="p-text-bold">Alternate Phone</div>
                                                <div class="p-text-normal">{{accountingAlternatePhone| mask:'(000) 000-0000'}}</div>
                                            </div>                              
                                        </div>                                   
                                    </div>
                                </div>                                
                            </p-accordionTab>
                        </p-accordion>
                    </div>
                </div>
                <div class="p-p-1">
                    <div>
                        <p-accordion [multiple]="true" >
                            <p-accordionTab header="Reference" [selected]="true">                                
                                <div class="p-fluid p-formgrid p-grid" *ngFor="let referenceField of referenceFields">
                                    <div class="p-field p-col-12 col-sm-3 col-md-3 col-lg-3">
                                        <div class="p-text-bold">Client Name</div>
                                        <div class="p-text-normal">{{referenceField.refClientName}}</div>
                                    </div>
                                    <div class="p-field p-col-12 col-sm-3 col-md-3 col-lg-3">
                                        <div class="p-text-bold">Contact Name</div>
                                        <div class="p-text-normal">{{referenceField.refContactName}}</div>
                                    </div>
                                    <div class="p-field p-col-12 col-sm-3 col-md-3 col-lg-3">
                                        <div class="p-text-bold">Contact Title</div>
                                        <div class="p-text-normal">{{referenceField.refContactTitle}}</div>
                                    </div>     
                                    <div class="p-field p-col-12 col-sm-3 col-md-3 col-lg-3">
                                        <div class="p-text-bold">Contact Email</div>
                                        <div class="p-text-normal">{{referenceField.refContactEmail}}</div>
                                    </div>
                                    <div class="p-field p-col-12 col-sm-3 col-md-3 col-lg-3">
                                        <div class="p-text-bold">Contact Phone</div>
                                        <div class="p-text-normal">{{referenceField.refContactPhoneNumber| mask:'(000) 000-0000'}}</div>
                                    </div>  
                                    <div class="p-field p-col-12 col-sm-3 col-md-3 col-lg-3">
                                        <div class="p-text-bold">Industry</div>
                                        <div class="p-text-normal">{{referenceField.refIndustry}}</div>
                                    </div>
                                    <div class="p-field p-col-12 col-sm-3 col-md-3 col-lg-3">
                                        <div class="p-text-bold">Duration of partnership</div>
                                        <div class="p-text-normal">{{referenceField.refDurationOfPartnership}}</div>
                                    </div>
                                    <div class="p-field p-col-12 col-sm-3 col-md-3 col-lg-3">
                                        <div class="p-text-bold">Revenue</div>
                                        <div class="p-text-normal">{{referenceField.refRevenue}}</div>
                                    </div>
                                    <div class="p-field p-col-12 col-sm-12 col-md-12 col-lg-12">
                                        <div class="p-text-bold">Services Provided</div>
                                        <div class="p-text-normal">{{referenceField.refServicesProvided}}</div>
                                    </div>                           
                                </div>  
                            </p-accordionTab>
                        </p-accordion>
                    </div>
                </div>
                <div class="p-p-1">
                    <div>
                        <p-accordion [multiple]="true">
                            <p-accordionTab header="Client Selection / Onboarding Documents" [selected]="true">
                                <div class="p-fluid p-formgrid p-grid">
                                    <div class="p-field p-col-12 col-sm-12 col-md-12 col-lg-12">
                                        <div class="p-text-bold custom-title-bar">Vendor Category</div>
                                        <div class="p-text-normal">{{vendorCategory}}</div>
                                    </div>
                                    <div class="p-field p-col-12 col-sm-12 col-md-12 col-lg-12">
                                        <div class="p-text-bold custom-title-bar">Selected Client(s)</div>
                                        <div class="p-text-normal">{{clientNames}}</div>
                                    </div>
                                    <div class="p-field p-col-12 col-sm-12 col-md-12 col-lg-12">
                                    <div class="p-text-sm custom-title-bar p-text-bold">COI Term Dates</div>                                        
                                    </div>
                                    <div class="p-field p-col-12 col-sm-3 col-md-3 col-lg-3">
                                        <div class="p-text-bold">General Liability Eff Date</div>
                                        <div class="p-text-normal">{{glEffDate}}</div>
                                    </div> 
                                    <div class="p-field p-col-12 col-sm-3 col-md-3 col-lg-3">
                                        <div class="p-text-bold">General Liability Exp Date</div>
                                        <div class="p-text-normal">{{glExpDate}}</div>
                                    </div> 
                                    <div class="p-field p-col-12 col-sm-3 col-md-3 col-lg-3">
                                        <div class="p-text-bold">Automobile Liability Eff Date</div>
                                        <div class="p-text-normal">{{alEffDate}}</div>
                                    </div> 
                                    <div class="p-field p-col-12 col-sm-3 col-md-3 col-lg-3">
                                        <div class="p-text-bold">Automobile Liability Exp Date</div>
                                        <div class="p-text-normal">{{alExpDate}}</div>
                                    </div> 
                                </div>
                                <div class="p-fluid p-formgrid p-grid">                                 
                                    <div class="p-field p-col-12 col-sm-3 col-md-3 col-lg-3">
                                        <div class="p-text-bold">Umbrella Liability Eff Date</div>
                                        <div class="p-text-normal">{{ulEffDate}}</div>
                                    </div> 
                                    <div class="p-field p-col-12 col-sm-3 col-md-3 col-lg-3">
                                        <div class="p-text-bold">Umbrella Liability Exp Date</div>
                                        <div class="p-text-normal">{{ulExpDate}}</div>
                                    </div> 
                                    <div class="p-field p-col-12 col-sm-3 col-md-3 col-lg-3">
                                        <div class="p-text-bold">Professional Liability Eff Date</div>
                                        <div class="p-text-normal">{{plEffDate}}</div>
                                    </div>
                                    <div class="p-field p-col-12 col-sm-3 col-md-3 col-lg-3">
                                        <div class="p-text-bold">Professional Liability Exp Date</div>
                                        <div class="p-text-normal">{{plExpDate}}</div>
                                    </div>
                               
                                </div>
                                <div class="p-fluid p-formgrid p-grid">               
                                 
                                    <div class="p-field p-col-12 col-sm-3 col-md-3 col-lg-3">
                                        <div class="p-text-bold">Workers Compensation Eff Date</div>
                                        <div class="p-text-normal">{{wcEffDate}}</div>
                                    </div> 
                                    <div class="p-field p-col-12 col-sm-4 col-md-4 col-lg-4">
                                        <div class="p-text-bold">Workers Compensation Exp Date</div>
                                        <div class="p-text-normal">{{wcExpDate}}</div>
                                    </div> 
                                    <div class="p-field p-col-12 col-sm-12 col-md-12 col-lg-12">
                                        <div class="p-text-bold">Comments</div>
                                        <div class="p-text-normal">{{comments}}</div>
                                    </div>
                                </div>
                                <div class="p-fluid p-formgrid p-grid">                                 
                                    <div class="p-field p-col-12 col-sm-3 col-md-3 col-lg-3">
                                        <div class="p-d-flex p-jc-between">
                                            <div class="p-text-bold">COI</div> 
                                            <div>
                                                <button  *ngIf="showInsuranceFile" pButton pRipple type="button" [style]="{width:'70px',height:'30px'}" (click)="ShowInsuranceUploadedFile()" label="View"  class="p-button-sm p-button-raised" style="margin-top: -3px;"></button>                                                
                                            </div>
                                        </div>                                       
                                    </div>
                                    <div class="p-field p-col-12 col-sm-3 col-md-3 col-lg-3">
                                        <div class="p-d-flex p-jc-between">
                                            <div class="p-text-bold">W9 Form</div> 
                                            <div>
                                                <button  *ngIf="showW9FormFile" pButton pRipple type="button" [style]="{width:'70px',height:'30px'}" (click)="Showw9UploadedFile()" label="View"  class="p-button-sm p-button-raised" style="margin-top: -3px;"></button>                                               
                                            </div>
                                        </div>                                       
                                    </div>
                                    <div class="p-field p-col-12 col-sm-3 col-md-3 col-lg-3">
                                        <div class="p-d-flex p-jc-between">
                                            <div class="p-text-bold">DD Authorization</div> 

                                            <div>
                                                <button  *ngIf="showDDAuthorizationFile" pButton pRipple type="button" [style]="{width:'70px',height:'30px'}" (click)="ShowDDAuthorizationUploadedFile()" label="View"  class="p-button-sm p-button-raised" style="margin-top: -3px;"></button>
                                               
                                            </div>
                                        </div> 
                                    </div>
                                    <div class="p-field p-col-12 col-sm-3 col-md-3 col-lg-3">
                                        <div class="p-d-flex p-jc-between">
                                            <div class="p-text-bold">MSA</div>
                                            <div>
                                                <button  *ngIf="showMsaFile" pButton pRipple type="button" [style]="{width:'70px',height:'30px'}" (click)="ShowMSAUploadedFile()" label="View"  class="p-button-sm p-button-raised" style="margin-top: -3px;"></button>                                               
                                            </div>
                                        </div> 
                                    </div>
                                </div>

                            </p-accordionTab>
                        </p-accordion>
                    </div>
                </div>
                <div class="p-p-1">
                    <div>
                        <div class="card">
                            <div class="card-header">
                              <h3 class="card-title"><span class="p-text-bold" style="font-family: Roboto,'system-ui',sans-serif;">Users List</span></h3>
                              <!-- <div class="card-tools">                               
                                <span class="badge badge-primary"><i class="pi pi-cog"></i></span>&nbsp;
                                <span><i class="pi pi-ellipsis-v"></i></span>

                              </div>                            -->
                            </div>                           
                            <div class="card-body">
                                <p-table #dt2 [value]="usersList" [resizableColumns]="true" columnResizeMode="expand" styleClass="p-datatable-gridlines" responsiveLayout="scroll">
                                    <ng-template pTemplate="header">
                                        <tr>
                                            <th pResizableColumn style="width: 8rem">User</th>
                                            <th pResizableColumn style="width: 6rem">Role</th>
                                            <th pResizableColumn style="width: 8rem">Email</th>
                                            <th pResizableColumn style="width: 6rem">Status</th>
                                            <th pResizableColumn style="width: 6rem">Created By</th>
                                            <th pResizableColumn style="width: 6rem">Created On</th>
                                            <th pResizableColumn style="width: 6rem">Modified On</th>
                                        </tr>
                                    </ng-template>
                                    <ng-template pTemplate="body" let-userApprovalList>
                                        <tr>
                                            <td><span class="table-col-countryName">{{userApprovalList.userName}}</span></td>
                                            <td><span>{{userApprovalList.accountType}}</span></td>
                                            <td><span>{{userApprovalList.primaryEmail}}</span></td>
                                            <td><span class="customer-badge status-active" *ngIf="userApprovalList.isActive">Active</span>
                                                <span class="customer-badge status-inactive" *ngIf="!userApprovalList.isActive">Inactive</span>
                                            </td>
                                            <td><span>{{userApprovalList.createdByUser.firstName}}</span></td>
                                            <td><span>{{userApprovalList.createdOn | date:'MM/dd/yyyy'}}</span></td>
                                            <td><span>{{userApprovalList.modifiedOn | date:'MM/dd/yyyy'}}</span></td>
                                        </tr>
                                    </ng-template>
                                    <ng-template pTemplate="emptymessage">
                                        <tr>
                                            <td colspan="5">No Users found.</td>
                                        </tr>
                                    </ng-template>
                                </p-table>
                            </div>                           
                            <div class="card-footer">
                              
                            </div>                            
                          </div>                         
                    </div>
                </div>
            </div>
            <div class="col-md-1"></div>
        </div>
    </div>
</section>

<section>
    <div class="row">
      <div class="col-md-1"></div>
      <div class="col-md-10">     
          <button pButton pRipple type="button" label="Back" icon="pi pi-arrow-left"
          class="p-button-outlined p-button-danger float-right m-2 bg-primary" (click)="backToPrev()"></button>
      </div>
      <div class="col-md-1"></div>
    </div>
  </section>
<!----------------main area----------------->
<!----------------main area----------------->

  <!-- <p-dialog [(visible)]="showInsurancePreview" [modal]="true"
  [style]="{width: '70vw',height:'80vh',overflow:'hidden',top:'7px'}" [draggable]="false" [resizable]="false">
  <ng-template pTemplate="header" class="font-accordion"><span>File Preview &nbsp;<a  target="_blank" [href]="coiFileDocUrl"><i class="fa fa-download" aria-hidden="true"></i></a></span>
  </ng-template>
    <br>
    <div class="card p-p-2">
        <div class="card-header">
           
        </div>     
        <div class="card-footer">
            <div class="p-fluid p-formgrid p-grid">
                <div class="p-field p-col-5 col-md-5 col-sm-5"></div>
                <div class="p-field p-col-2 col-md-2 col-sm-2">
                  <p-progressSpinner [style]="{height:'80vh'}" class="p-ai-center" *ngIf="!showCOIFilePreview"></p-progressSpinner>
              </div>
              <div class="p-field p-col-5 col-md-5 col-sm-5"></div>               
              <div class="p-field p-col-12 col-md-12 col-sm-12">
              <ngx-doc-viewer *ngIf="showCOIFilePreview" [url]="coiFileDocUrl" disableContent="popout"
              viewer="google" style="width:100%;height:80vh;"></ngx-doc-viewer>
              </div>
            </div> 
          </div>
    </div>
 </p-dialog> -->

  <!-- <p-dialog [(visible)]="showPreview" [modal]="true"
  [style]="{width: '70vw',height:'80vh',overflow:'hidden',top:'7px'}"[draggable]="false" [resizable]="false">
  <ng-template pTemplate="header" class="font-accordion"><span>File Preview &nbsp;<a  target="_blank" [href]="w9FileDocUrl"><i class="fa fa-download" aria-hidden="true"></i></a></span>
  </ng-template>
    <br>
    <div class="card p-p-2">
        <div class="card-header">
           
        </div>     
        <div class="card-footer">
            <div class="p-fluid p-formgrid p-grid">
                <div class="p-field p-col-5 col-md-5 col-sm-5"></div>
                <div class="p-field p-col-2 col-md-2 col-sm-2">
                  <p-progressSpinner [style]="{height:'80vh'}" class="p-ai-center" *ngIf="!showW9FilePreview"></p-progressSpinner>
              </div>
              <div class="p-field p-col-5 col-md-5 col-sm-5"></div>               
              <div class="p-field p-col-12 col-md-12 col-sm-12">
                <ngx-doc-viewer *ngIf="showW9FilePreview" [url]="w9FileDocUrl" disableContent="popout"
                viewer="google" style="width:100%;height:80vh;">
            </ngx-doc-viewer>
              </div>
            </div> 
          </div>
    </div>
 </p-dialog> -->

  <!-- <p-dialog  [(visible)]="showDDPreview" [modal]="true"
  [style]="{width: '70vw',height:'80vh',overflow:'hidden',top:'7px'}" [draggable]="false" [resizable]="false">
  <ng-template pTemplate="header" class="font-accordion"><span>File Preview &nbsp;<a  target="_blank" [href]="ddFileDocUrl"><i class="fa fa-download" aria-hidden="true"></i></a></span>
  </ng-template>
    <br>
    <div class="card p-p-2">
        <div class="card-header">
        </div>     
        <div class="card-footer">
            <div class="p-fluid p-formgrid p-grid">
                <div class="p-field p-col-5 col-md-5 col-sm-5"></div>
                <div class="p-field p-col-2 col-md-2 col-sm-2">
                 <p-progressSpinner [style]="{height:'80vh'}" class="p-ai-center" *ngIf="!showDDFilePreview"></p-progressSpinner>
              </div>
              <div class="p-field p-col-5 col-md-5 col-sm-5"></div>               
              <div class="p-field p-col-12 col-md-12 col-sm-12">
                <ngx-doc-viewer *ngIf="showDDFilePreview" [url]="ddFileDocUrl" disableContent="popout"
                  viewer="google" style="width:100%;height:80vh;">
                </ngx-doc-viewer>
              </div>
            </div> 
          </div>
    </div>
 </p-dialog> -->
  <!-- <p-dialog [(visible)]="showMSAPreview" [modal]="true"
  [style]="{width: '70vw',height:'80vh',overflow:'hidden',top:'7px'}" [draggable]="false" [resizable]="false">
  <ng-template pTemplate="header" class="font-accordion"><span>File Preview &nbsp;<a  target="_blank" [href]="msaFileDocUrl"><i class="fa fa-download" aria-hidden="true"></i></a></span>
  </ng-template>
    <br>
    <div class="card p-p-2">
        <div class="card-header">
        </div>     
        <div class="card-footer">
            <div class="p-fluid p-formgrid p-grid">
                <div class="p-field p-col-5 col-md-5 col-sm-5"></div>
                <div class="p-field p-col-2 col-md-2 col-sm-2">
                  <p-progressSpinner [style]="{height:'80vh'}" class="p-ai-center" *ngIf="!showMSAFilePreview"></p-progressSpinner>
              </div>
              <div class="p-field p-col-5 col-md-5 col-sm-5"></div>               
              <div class="p-field p-col-12 col-md-12 col-sm-12">
                <ngx-doc-viewer *ngIf="showMSAFilePreview" [url]="msaFileDocUrl" disableContent="popout"
                  viewer="google" style="width:100%;height:80vh;">
                </ngx-doc-viewer>
              </div>
            </div> 
          </div>
    </div>
 </p-dialog> -->
